<template>
  <el-container class="container">
    <!-- 顶部栏 -->
    <el-header class="header">
      <div class="logo">
        <img alt="" height="30px" src="@/assets/image/logo.png"/>
        <div class="logoVersion">{{ version }}</div>
      </div>
      <headerList @click="onClickDialog"></headerList>
    </el-header>

    <!-- 主内容 -->
    <el-container class="main">
      <!-- <iframe id="cloudConsole" width="0" height="0" src="https://console.cloud.tencent.com/cvm/instance/index?rid=33" frameborder="0"></iframe> -->
      <!-- 侧边栏 -->
      <el-aside class="aside">
        <menuList></menuList>
      </el-aside>

      <!-- 登录腾讯云 暂时注释 -->
      <!-- <el-components :title="$t('workbench.loginTencentCloud')" width="30%" :visible.sync="dialogLoginVisible">
        <span>{{ $t('workbench.pleaseLoginTencentCloud') }}</span>&nbsp;&nbsp;&nbsp;&nbsp;
        <el-button type="primary" @click="tencntcloudLogin">{{ $t('workbench.loginAuth') }}</el-button>
      </el-components> -->

      <!-- 服务协议 -->
      <el-dialog :close-on-click-modal="false" :show-close="false"
                 :visible.sync="dialogAgreementVisible"
                 center
                 class="agreement-dialog_style"
                 width="998px"
      >
        <template #title>
          <span class="agreement-dialog_title">{{ $t('workbench.serviceAgreement') }}</span>
        </template>
        <agreement></agreement>
        <template #footer>
          <el-button @click="goLogin">{{ $t('workbench.cancel') }}</el-button>
          <el-button type="primary" @click="confirmAgreement">
            {{ $t('workbench.agree') }}
          </el-button>
        </template>
      </el-dialog>

      <!-- 加入团队申请 -->
      <el-dialog :close-on-click-modal="false" :title="$t('workbench.joinTeamApplication')"
                 :visible.sync="dialogProjectApplyVisible"
                 class="dialogEDA"
                 destroy-on-close
                 width="800px"
      >
        <project-apply @click="onClickDialog"></project-apply>
      </el-dialog>

      <!-- 选择机型配置 -->
      <el-dialog
        :title="$t('workbench.selectInstanceType')"
        :visible.sync="dialogSelectModelVisible"
        class="dialogEDA"
        width="600px"
      >
        <template #title>
          <h1>{{ $t('workbench.selectInstanceType') }}</h1>
        </template>
        <selectModel ref="selectModel" @close="closeSelectModel"></selectModel>
      </el-dialog>

      <!-- 绑定邮箱/修改邮箱 -->
      <el-dialog
        :close-on-click-modal="false"
        :title="userInfo.email ? $t('workbench.modifyEmail') : $t('workbench.bindEmail')"
        :visible.sync="bandEmailVisable"
        width="520px"
        @close="resetForm"
      >
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          label-position="left"
          label-width="100px"
        >
          <el-form-item
            :label="userInfo.email ? $t('workbench.newEmailAddress') : $t('workbench.emailAddress')"
            :rules="[
              { required: true, message: $t('workbench.pleaseEnterEmail'), trigger: 'change' },
              {
                type: 'email',
                message: $t('workbench.pleaseEnterCorrectEmail'),
                trigger: ['blur', 'change'],
              },
            ]"
            prop="email"
          >
            <el-input v-model="ruleForm.email"></el-input>
          </el-form-item>

          <el-form-item
            :label="$t('workbench.verificationCode')"
            :rules="[
              { required: true, message: $t('workbench.pleaseEnterVerificationCode'), trigger: 'change' },
            ]"
            prop="verificationCode"
          >
            <el-input
              v-model="ruleForm.verificationCode"
            >
              <template slot="append">
                <el-button
                  v-if="!activeBtn"
                  class="btn_style btn_style_width_102"
                  @click="getEmailCheckCode"
                >{{ $t('workbench.getVerificationCode') }}
                </el-button
                >
                <el-button v-if="activeBtn" class="btn_style btn_style_width_102">
                  {{ $t('workbench.retryAfter', {second: codeTime}) }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="resetForm()">{{ $t('workbench.cancel') }}</el-button>
          <el-button
            class="btn_style btn_style_width_88"
            type="primary"
            @click="bandEmailSubmitForm('ruleForm')"
          >{{ $t('workbench.confirmModify') }}</el-button
          >
        </span>
      </el-dialog>

      <el-container>
        <el-main :class="computedClass">
          <router-view @click="onClickDialog"></router-view>
        </el-main>
        <el-footer
        >{{ $t('workbench.copyright', {year: new Date().getFullYear()}) }}
        </el-footer
        >
      </el-container>
    </el-container>

    <!-- 创建团队 -->
    <createTeamDialog/>
  </el-container>
</template>

<script>
import {TENCENT_CLOUD_AUTH_URL, TENCENT_CLOUD_UNAUTH_URL} from '@/common/constants';
import headerList from '@/components/header';
import menuList from '@/components/menu';
import createTeamDialog from '@/components/createTeamDialog';
import {getRequest, postRequest} from '@/common/libs/request';
import selectModel from './components/selectModel';
import agreement from './components/agreement';
import projectApply from './components/projectApply';

const headerTitleObj = {
  monitor: 'workbench.resourceMonitor',
  team: 'workbench.teamManagement',
  secretKey: 'workbench.secretKeyManagement',
};

export default {
  name: 'workbench',
  components: {
    agreement,
    projectApply,
    selectModel,
    menuList,
    headerList,
    createTeamDialog,
  },
  data() {
    return {
      currentTab: '',
      currentProject: {},
      headerTitle: '',
      projectList: [],
      tableUserData: [],
      fullscreenLoading: null,
      connected: false,
      display: null,
      currentAdjustedHeight: null,
      client: null,
      keyboard: null,
      mouse: null,
      lastEvent: null,
      errorMessage: '',
      arguments: {},
      dialogLoginVisible: false,
      dialogAgreementVisible: false,
      dialogNewProjectVisible: false,
      dialogProjectApplyVisible: false,
      dialogProjectUserListVisible: false,
      envInfo: {},
      userInfo: {},
      dialogSelectModelVisible: false,
      bandEmailVisable: false,
      ruleForm: {
        email: '',
        verificationCode: '',
      },
      codeTime: 60,
      activeBtn: false,
      version: '',
      currentPath: this.$route.path,
    };
  },
  computed: {
    computedClass() {
      let computedCls = '';
      if (
        this.currentPath === '/workbench/customDetail'
        || this.currentPath === '/workbench/computingCluster'
        || this.currentPath === '/workbench/cloudPlatform'
        || this.currentPath === '/workbench/multiCloudCluster'
        || this.currentPath === '/workbench/multiCloudClusterDetail'
      ) {
        computedCls = 'padding-0';
      }
      return computedCls;
    },
  },
  watch: {
    connectionState(state) {
      this.$notify({
        title: state,
        type: 'success',
      });
    },
    dialogSelectModelVisible: {
      handler(e) {
        if (!e) {
          this.$refs.selectModel.close();
        }
      },
    },
    $route: {
      immediate: true,
      handler(newVal) {
        this.currentPath = newVal.path;
      },
    },
  },
  async created() {
    await this.getUserInfo();
    this.getVersion();
    this.changeTab(this.$route.name);
    this.checkUserTencentAccount();
  },
  methods: {
    checkUserTencentAccount() {
      const loginType = sessionStorage.getItem('loginType');
      if (loginType === 'cloud') {
        postRequest('/api/eda/common/eda/checkUserTencentAccount').then((res) => {
          if (!res.allow) {
            this.$notify({
              title: this.$t('workbench.warning'),
              message: this.$t('workbench.subAccountPermissionWarning'),
              type: 'warning',
              duration: 0,
            });
          }
        });
      }
    },
    getVersion() {
      getRequest('/api/common/getSetting?key=version').then((res) => {
        this.version = res;
      });
    },
    changeTab(val) {
      if (this.currentTab !== val && this.currentTab !== '') {
        this.$router.push(val);
      }
      this.currentTab = val;
      this.headerTitle = this.$t(headerTitleObj[this.currentTab]) || '';
    },
    async getUserInfo() {
      try {
        const res = await getRequest('/api/eda/common/eda/getUserInfo');
        this.userInfo = res || {};
        this.dialogAgreementVisible
          = this.userInfo.agreementVersion === undefined
          || this.userInfo.agreementVersion === null
          || this.userInfo.agreementVersion === '';
      } catch (e) {
      }
    },
    async confirmAgreement() {
      await postRequest('/api/eda/common/eda/updateAgreement', {
        version: '1.0.0',
      });
      this.dialogAgreementVisible = false;
    },
    onClickDialog(name) {
      switch (name) {
        case 'add':
          this.dialogProjectApplyVisible = false;
          this.dialogNewProjectVisible = true;
          break;
        case 'apply':
          this.dialogProjectApplyVisible = true;
          this.dialogNewProjectVisible = false;
          break;
        case 'create':
          this.dialogProjectApplyVisible = false;
          this.dialogNewProjectVisible = false;
          this.dialogLoginVisible = true;
          break;
        case 'bandEmail':
          this.bandEmailVisable = true;
          break;
        default:
          this.dialogProjectApplyVisible = false;
          this.dialogNewProjectVisible = false;
          this.dialogLoginVisible = false;
          break;
      }
    },
    async logout() {
      try {
        await getRequest('/api/common/logout');
      } catch (e) {
      }
      window.location.href = TENCENT_CLOUD_UNAUTH_URL;
    },
    async getProjectUserList(projectId) {
      try {
        const res = await postRequest('/api/eda/common/project/getProjectUserList', {
          projectId,
        });
        this.tableUserData = res.list || [];
        this.dialogProjectUserListVisible = true;
      } catch (e) {
        this.$message(this.$t('workbench.getProjectListError'));
      }
    },
    async openCanvas(currentProject) {
      window.open(`/remoteDestop?projectId=${currentProject.id}`);
    },
    tencntcloudLogin() {
      window.location.href = TENCENT_CLOUD_AUTH_URL;
    },
    closeSelectModel() {
      this.dialogSelectModelVisible = false;
    },
    goLogin() {
      this.dialogAgreementVisible = false;
      this.$router.replace('/login');
    },
    bandEmailSubmitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          postRequest('/api/eda/common/eda/updateEmail', {
            email: this.ruleForm.email,
            code: this.ruleForm.verificationCode,
          }).then(() => {
            this.$message.success(this.$t('workbench.updateEmailSuccess'));
            this.$store.dispatch('app/getUserInfo');
          });
          this.bandEmailVisable = false;
        }
      });
    },
    resetForm() {
      this.bandEmailVisable = false;
      this.$refs.ruleForm.resetFields();
      this.activeBtn = false;
    },
    getEmailCheckCode() {
      this.$refs.ruleForm.validateField('email', (valid) => {
        if (valid === '') {
          if (this.userInfo.email === this.ruleForm.email) return this.$message.error(this.$t('workbench.newEmailSameAsOld'));
          postRequest('/api/eda/common/notify/sendEmailCode', {
            email: this.ruleForm.email,
          }).then(() => {
            this.$message.success(this.$t('workbench.verificationCodeSent'));
          });
          this.activeBtn = true;
          this.emailTimeEvent();
        }
      });
    },
    emailTimeEvent() {
      const tm = setTimeout(() => {
        if (this.codeTime > 0) {
          this.codeTime -= 1;
          this.emailTimeEvent();
        } else {
          this.activeBtn = false;
          this.codeTime = 60;
          clearTimeout(tm);
        }
      }, 1000);
    },
  },
};
</script>
<style lang="scss">

.container {
  text-align: left;
  background: #eee;
  height: 100vh;
  width: 100vw;

  .main {
    overflow: hidden;
  }

  .el-header {
    border-bottom: 1px solid #e7e7e7;
    line-height: 30px;
    padding: 0;
    background: #fff;

    .logo {
      padding: 14px 0 14px 24px;
      width: 233px;
      float: left;
      height: 100%;
      border-right: 1px solid #e7e7e7;
      position: relative;
      box-sizing: border-box;
    }

    .logoVersion {
      position: absolute;
      z-index: 999;
      left: 142px;
      bottom: 9px;
      font-size: 12px;
    }

    .header-btn {
      float: right;
      padding: 10px 24px 0 0;
    }

    .title {
      display: inline-block;
      font-weight: normal;
      font-size: 20px;
      line-height: 28px;
      padding: 14px 0 14px 24px;
      overflow: hidden;
      vertical-align: top;
    }

    .proejct-select {
      display: inline-block;
      vertical-align: top;
      padding: 6px 0 0 10px;
    }
  }

  .aside {
    position: relative;
    //padding: 8px 15px;
    background: #fff;
    border-right: 1px solid #e7e7e7;
    width: auto !important;

    .tab {
      background: #fff;
      border-radius: 3px;
      display: block;
      line-height: 22px;
      padding: 7px 0 7px 16px;
      display: block;
      margin-bottom: 4px;
      width: 200px;
      text-align: left;
      color: #000;

      &:hover {
        background: rgba(236, 242, 254, 1);
      }

      &.on {
        background: rgba(236, 242, 254, 1);
        color: #409eff;
      }
    }

    .bottom {
      position: absolute;
      left: 0;
      bottom: 12px;
      width: 100%;

      .user-info {
        line-height: 32px;
        padding-left: 8px;

        .figure {
          width: 32px;
          height: 32px;
          vertical-align: top;
          border-radius: 50%;
          margin-right: 7px;
        }

        .nickname {
          font-size: 14px;
          color: #666;
        }
      }

      .btn {
        float: right;
        margin: -38px 0 0;
        width: 100px;
      }
    }
  }

  .el-main {
    padding: 20px 24px 0;
  }

  .overview {
    display: flex;
    font-family: "PingFangSC-Semibold";
    color: rgba(0, 0, 0, 0.9);
    margin-bottom: 20px;

    .flex {
      display: flex;
    }

    .overview-title {
      font-size: 16px;
      font-weight: normal;
      margin-bottom: 20px;
    }

    .flex-1 {
      flex: 1;
      background: #fff;
      padding: 7px 20px 20px;
    }

    .split {
      margin-right: 10px;
    }

    .taskStyle {
      min-width: 160px;
      padding: 0 20px 10px 0;
      margin-right: 20px;
      box-sizing: border-box;
      width: 100px;
      flex: 1;

      &.border-right {
        border-right: 1px solid #e7e7e7;
      }
    }

    .overview-subtitle {
      font-size: 14px;
      line-height: 28px;
      margin-bottom: 12px;
    }

    .overview-text {
      font-family: Arial;
      font-size: 36px;
      text-align: center;

      .unit {
        font-size: 12px;
        padding-right: 10px;
      }
    }
  }

  .history {
    font-family: "PingFangSC-Semibold";
    margin-top: 20px;
    background: #fff;

    .history-title {
      font-size: 16px;
      font-weight: normal;
      padding: 7px 20px 0;
    }
  }
}

.el-input {
  width: 100%;
}

.display {
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.viewport {
  //background-color: coral;
  //border-color: blue;
  //border-width: 1px;
  position: relative;
  width: 100%;
  height: 100%;
}

.btn {
  width: 200px;
  margin-bottom: 20px;
}

.dialogEDA ::v-deep .el-dialog {
  margin-top: 50px !important;
}

.agreement-dialog_style {
  .agreement-dialog_title {
    opacity: 1;
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: 400;
    font-family: "PingFang SC";
    line-height: 24px;
  }

  ::v-deep .el-dialog__header {
    padding: 20px;
  }

  ::v-deep .el-dialog--center {
    height: 774px;
  }

  ::v-deep .el-dialog__body {
    padding-top: 0;
  }
}

.el-footer {
  height: 56px !important;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);
  font-weight: 400;
  font-family: "PingFang SC";
  text-align: center;
  background-color: #eee;
  line-height: 56px;
}

.el-form {
  ::v-deep .el-form-item__label:before {
    content: "" !important;
    margin: 0 !important;
  }
}

.btn_style {
  padding: 12px 0;
  color: #ffffff;
  background: #0052d9;
}

.btn_style_width_102 {
  width: 102px;
}

.btn_style_width_88 {
  width: 88px;
}

.padding-0 {
  padding: 0 !important;
}
</style>
